module.exports = __webpack_public_path__ + "static/img/news_25.f703026.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_25.jpg
// module id = PyOU
// module chunks = 2